'use client';
import { ListboxList } from '../listbox/listbox-list.component.js';

const ComboboxList = ListboxList;

export { ComboboxList };
